import type { QRCodeToDataURLOptions } from 'qrcode';

export async function generateQrCodeFromNumbers(
  numbersString: string,
  options?: QRCodeToDataURLOptions
) {
  const QRCode = await import('qrcode');
  console.log('[generateQr] Generatnig Qr string');
  return QRCode.toDataURL([{ data: numbersString, mode: 'numeric' }], options);
}

export async function generateQrCodeFromText(
  text: string,
  options?: QRCodeToDataURLOptions
) {
  const QRCode = await import('qrcode');
  console.log('[generateQr]', text);
  return QRCode.toDataURL(text, { ...options });
  // return QRCode.toDataURL([{ data: text, mode: 'alphanumeric' }], options);
}
